import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {client} from "../../services/api-client";
import {AxiosError} from "axios";
import {toast} from "react-toastify";


interface IUpdatePasswordReq {
    email: string,
    password: string,
    codeFromEmail: string
}

interface ILoginResp {
    is2FA: boolean,
    isFirstSet: boolean,
    message: null | string,
    user: {
        id: number,
        email: string,
        name: string,
        isAllowed: boolean,
        is2FA: boolean,
        clientId: number,
        client: {
            id: number,
            name: string
        },
        roles: string[],
        permissions: []
    },
    token: {
        token: string,
        expires: string
    }
}

export interface ILoginPayload {
    email: string,
    password: string
}

interface AuthState {
    isSentCode: boolean,
}

const initialState: AuthState = {
    isSentCode: false
};


export const login = createAsyncThunk<ILoginResp, ILoginPayload, { rejectValue: string }>(
    'auth/login',
    async (payload, {rejectWithValue}) => {
        try {
            const {data} = await client.post(`api/auth/login`, payload);
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const getResetCode = createAsyncThunk<ILoginResp, { email: string }, { rejectValue: string }>(
    'auth/get-reset-code',
    async (payload, {rejectWithValue}) => {
        try {
            const {data} = await client.post(`api/auth/code`, payload);
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const updatePassword = createAsyncThunk<ILoginResp, IUpdatePasswordReq, { rejectValue: string }>(
    'auth/update-password',
    async (payload, {rejectWithValue}) => {
        try {
            const {data} = await client.post(`api/auth/code`, payload);
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const refreshToken = createAsyncThunk<any, { token: string }, { rejectValue: string }>(
    'auth/refresh-token',
    async (payload, {rejectWithValue}) => {
        try {
            const {data} = await client.post(`api/auth/refresh`, payload);
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout() {
            localStorage.removeItem('sdc-token');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.fulfilled, (state, action) => {
                if (action.payload.token) {
                    localStorage.setItem("sdc-token", action.payload.token.token)
                    window.location.href = "/players"
                } else if (!action.payload.isFirstSet) {
                    toast.error(action.payload.message)
                }
            })
            .addCase(getResetCode.fulfilled, (state, action) => {
                state.isSentCode = true;
            })
            .addCase(getResetCode.rejected, (state, action) => {
                state.isSentCode = true;
            })
            .addCase(updatePassword.fulfilled, (state, action) => {
                state.isSentCode = false;
                if (action.payload.token) {
                    localStorage.setItem("sdc-token", action.payload.token.token)
                    window.location.href = "/players"
                } else if (!action.payload.isFirstSet) {
                    toast.error(action.payload.message)
                }
            })
    }
});

export const {logout} = authSlice.actions;
export default authSlice.reducer;
